import { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import { MultiselectDropdownUiOptions } from './schema';

export { MultiselectDropdownFieldSchema } from './schema';

export const MultiselectDropdown = (
  props: FieldExtensionComponentProps<string[], MultiselectDropdownUiOptions>,
) => {
  const {
    schema: { title = '', description = '', uniqueItems = true },
    uiSchema = { 'ui:placeholder': 'placeholder' },
    required,
    formData,
    onChange,
    idSchema,
  } = props;

  const multiselectOptions = (uiSchema['ui:options']?.items as string[]) ?? [
    'test',
  ];

  const [selectedItems, setSelectedItems] = useState<string[]>(formData ?? []);
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>(
    typeof uiSchema['ui:options']?.errorMessage === 'string'
      ? uiSchema['ui:options']?.errorMessage
      : '',
  );

  useEffect(() => {
    setSelectedItems(formData ?? selectedItems);
    setError(!!(required && selectedItems.length === 0));
    setErrorMessage(() => {
      if (required && touched) {
        return 'At least one item has to be selected.';
      } else if (required) {
        return description;
      }

      return '';
    });
  }, [formData, selectedItems, description, required, touched]);

  const handleChange = async (
    _event: React.SyntheticEvent<Element, Event>,
    newValue: string | string[] | null,
  ) => {
    setTouched(true);
    onChange?.(newValue as string[]);
  };

  return (
    <Autocomplete
      multiple={uniqueItems}
      id={idSchema?.$id}
      options={multiselectOptions}
      value={selectedItems}
      onChange={handleChange}
      getOptionLabel={option => option}
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          label={title}
          placeholder={
            selectedItems.length > 0 ? '' : uiSchema['ui:placeholder']
          }
          helperText={error && touched ? errorMessage : description}
          error={error && touched}
          required={error}
        />
      )}
    />
  );
};
